import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    NumberField,
    BooleanField,
} from 'react-admin';
import ScheduleTitle from './ScheduleTitle';
import RecurrenceField from './RecurrenceField'
import NextOccurenceField from './NextOccurenceField'

const ScheduleShow = props => (
    <Show title={<ScheduleTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <ReferenceField label="Resource" source="resource_id" reference="resources">
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Target" source="target_id" reference="targets">
                <TextField source="name" />
            </ReferenceField>
            <BooleanField source="enabled" />
            <NumberField source="max_duration" label="Max duration (seconds)" />
            <TextField source="start_time" />
            <RecurrenceField source="rrule" label="Occures" addLabel />
            <NextOccurenceField source="rrule" label="Next occurance" addLabel />
            <TextField source="rrule" />
        </SimpleShowLayout>
    </Show>
);

export default ScheduleShow;